module.exports = __webpack_public_path__ + "static/media/sudhirpic.a727ea25.png";